import { get, post, postImageAxios } from "helpers/api_helper"
import { put, takeEvery } from "redux-saga/effects"
import { getFormDataFromJSON, showToast } from "utils"
import {
  getContactUsSetupFailed,
  getContactUsSetupSuccess,
  getUserListFailed,
  getUserListSuccess,
  updateContactUsSetupFailed,
  getContactUsSetup as getContactUsSetupAction,
  updateContactUsSetupSuccess,
  updateContactDataFailed,
  updateContactDataSuccess,
} from "./actions"
import {
  GET_CONTACT_US_SETUP,
  GET_USER_LIST,
  UPDATE_CONTACT_DATA,
  UPDATE_CONTACT_US_SETUP,
} from "./actionTypes"
import * as url from "helpers/url_helper"

function* getContactUsSetup({ payload: params }) {
  try {
    const response = yield get("/contact-us/setup", { params })
    yield put(getContactUsSetupSuccess(response))
  } catch (error) {
    yield put(getContactUsSetupFailed(error))
    showToast("error", error, "Error")
  }
}

function* getUserList({ payload: params }) {
  try {
    const response = yield get(url.ADMIN_USER_URL, { params })
    yield put(getUserListSuccess(response))
  } catch (error) {
    yield put(getUserListFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateContactUsSetup({ payload: params }) {
  try {
    let background = null
    if (params?.uploadBackgroundImage) {
      background = yield postImageAxios(
        "/file",
        getFormDataFromJSON(params.bgImage)
      )
    }
    const response = yield post("/contact-us/setup", {
      ...params.values,
      ...(background
        ? {
            bg_image_file: background[0],
            bg_image_url: null,
          }
        : {}),
    })
    yield put(updateContactUsSetupSuccess(response))
    yield put(getContactUsSetupAction({ dashboard: true }))
    showToast("success", "Contact Us Screen Updated!", "Success")
  } catch (error) {
    yield put(updateContactUsSetupFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateContactData({ payload: params }) {
  try {
    const response = yield post("/contact-us/user", params?.values)
    yield put(updateContactDataSuccess(params?.values))
    if (params?.type !== "reorder") {
      yield put(getContactUsSetupAction({ dashboard: true }))
      showToast("success", "Data successfully saved!", "Success")
    }
  } catch (error) {
    yield put(updateContactDataFailed(error))
    showToast("error", error, "Error")
  }
}

function* contactUsScreenSaga() {
  yield takeEvery(GET_CONTACT_US_SETUP, getContactUsSetup)
  yield takeEvery(GET_USER_LIST, getUserList)
  yield takeEvery(UPDATE_CONTACT_US_SETUP, updateContactUsSetup)
  yield takeEvery(UPDATE_CONTACT_DATA, updateContactData)
}

export default contactUsScreenSaga
